import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableSimpleSearch } from '@/common/ui/table/data-table-simple-search'

import { GetBlacklistResponse } from '../../type'
import { createBlacklistTableColumns } from './constants'
import { BlacklistFormModal } from '../BlacklistFormModal'

interface BlacklistTableProps {
	data: GetBlacklistResponse['data']
	total: number
	isLoading?: boolean
}

export default function BlacklistTable({
	data,
	total,
	isLoading,
}: BlacklistTableProps) {
	const columns = createBlacklistTableColumns()

	return (
		<div className="space-y-4">
			{/* Header with create button */}
			<div className="flex items-center justify-between">
				<div /> {/* Spacer */}
				<BlacklistFormModal />
			</div>

			{/* Filters */}
			<div className="flex flex-wrap items-end gap-4">
				<DataTableSimpleSearch placeHolder="ค้นหาเลขบัญชี, ชื่อบัญชี" />
			</div>

			{/* Table */}
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
